import { API_BASE, devSession } from '@platform/dao';
import { HttpClient } from '@platform/dao/HttpClient';
import { baseApi, listTag, run } from '@platform/state/api/baseApi';
import { nextCodeOf } from '../nextCodeOf';
import type { INextCodeArg } from './INextCodeArg';

/** Транспорт запиту, якого ще немає в DAO платформи (той самий базовий URL і заголовки, що й dao: мова, Dev-користувач). */
const http = new HttpClient({
  baseUrl: API_BASE,
  headers: () => ({ 'Accept-Language': devSession.lang, ...(devSession.user ? { 'X-Dev-User': devSession.user } : {}) }),
});

/**
 * Точний номер, який отримає новий запис типу (GET /workspaces/{ws}/records/{rt}/next-code — лічильник типу + 1); кешується зі списковим
 * тегом типу, тож створення чи видалення запису оновлює номер чернетки.
 */
export const nextCodeApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    nextCode: b.query<number | null, INextCodeArg>({
      queryFn: ({ ws, rt }) => run(async () => nextCodeOf(await http.get<unknown>(`/workspaces/${ws}/records/${encodeURIComponent(rt)}/next-code`))),
      providesTags: (_r, _e, { rt }) => [listTag(rt)],
    }),
  }),
});

export const { useNextCodeQuery } = nextCodeApi;
